import { RefObject } from "react";
import { ViewTableHandle } from "@design-system/ViewTable/ViewTable";

// Scrolls a nested-editor row into view before its cell is focused. Deliberately
// does not expand: the focus helper calls this on every retry frame, and writing
// expanded state repeatedly overwrites the level-by-level expansion ViewTable
// runs on mount, leaving rows collapsed that it will never retry. Callers that
// genuinely need an expand do it once, from the gesture. A row missing from the
// rendered model is a no-op, so the retries double as "wait until it exists".
export const scrollNestedRowIntoView = (
    tableRef: RefObject<ViewTableHandle | null>,
    rowId: string,
    align: "auto" | "center" = "auto",
): void => {
    tableRef.current?.scrollToRow(rowId, { align });
};
